// The given name a therapist files under. A professional title is a prefix, not part
// of the name — a roster where every doctor sits under ד׳ is not sorted by name at
// all. Mirrors `_sort_name` in backend/app/services/exec_salary.py, which decides the
// default order of the payroll table; both screens must agree or clicking "מטפל"
// would reorder rows that were already alphabetical.
const TITLE = /^\s*(?:ד["״׳]?ר\.?|פרופ['׳]?\.?|dr\.?|prof\.?)\s+/i;

export const firstName = (t: { hebrew_name?: string | null; name: string }) => {
  const full = (t.hebrew_name || t.name || '').replace(TITLE, '').trim();
  return full.split(/\s+/)[0] || full;
};
